import React, { useState } from "react";
import { IconButton, useMediaQuery } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import JDPACustomButton2 from "./JDPACustomButton2";
import JDPACustomButtonMenu2 from "./JDPACustomButtonMenu2";

const ExpandableJDPACustomButton2 = ({open, onClick}) => {

    const isMobile = useMediaQuery('(max-width: 768px)');

    if (!isMobile) {
        return <JDPACustomButton2 />;
    }

    return (
        <div>
            <div className="menu-category-title-row clickable-row" onClick={onClick}>
                <span className="menu-category-title">Pricing & Values</span>
                <IconButton size="small" className="expandable-icon">
                    {open ? <RemoveIcon className="expandable-icon" /> : <AddIcon className="expandable-icon" />}
                </IconButton>
            </div>
            {open && (
                <div className="expandable-content">
                    <JDPACustomButtonMenu2 />
                </div>
            )}
        </div>
    );
};

export default ExpandableJDPACustomButton2;